"use strict";
exports.__esModule = true;
exports.Records = void 0;
var getNodes = function (record) { return Object.values(record.nodes || {}); };
var getRoot = function (record) {
    var root = getNodes(record).find(function (node) { return !node.parentUuid; });
    if (!root)
        throw new Error('Record root not found');
    return root;
};
var getChildren = function (params) {
    var record = params.record, childDefUuid = params.childDefUuid, parentNode = params.parentNode;
    return getNodes(record).filter(function (node) { return node.parentUuid === parentNode.uuid && node.nodeDefUuid == childDefUuid; });
};
var getChild = function (params) {
    var children = getChildren(params);
    if (children.length > 1)
        throw new Error('Multiple nodes found');
    if (children.length === 0)
        throw new Error('Child not found');
    return children[0];
};
var getParent = function (params) {
    var record = params.record, node = params.node;
    var nodes = getNodes(record);
    var parent = nodes.find(function (n) { return n.uuid === node.parentUuid; });
    return parent;
};
var getAncestor = function (params) {
    var record = params.record, node = params.node, ancestorDefUuid = params.ancestorDefUuid;
    if (node.nodeDefUuid === ancestorDefUuid)
        return node;
    var ancestor = getParent({ record: record, node: node });
    while (ancestor && ancestor.nodeDefUuid !== ancestorDefUuid) {
        ancestor = getParent({ record: record, node: ancestor });
    }
    if (!ancestor) {
        throw new Error("Ancestor with ancestorDefUuid ".concat(ancestorDefUuid, " not found for node with uuid ").concat(node.uuid, " and node def uuid ").concat(node.nodeDefUuid));
    }
    return ancestor;
};
var getDescendant = function (params) {
    var record = params.record, node = params.node, nodeDefDescendant = params.nodeDefDescendant;
    var nodeDescendantH = nodeDefDescendant.meta.h;
    var descendant = nodeDescendantH
        .slice(nodeDescendantH.indexOf(node.nodeDefUuid) + 1)
        .reduce(function (parentNode, childDefUuid) { return getChild({ record: record, parentNode: parentNode, childDefUuid: childDefUuid }); }, node);
    return descendant;
};
exports.Records = { getRoot: getRoot, getChild: getChild, getChildren: getChildren, getParent: getParent, getAncestor: getAncestor, getDescendant: getDescendant };
//# sourceMappingURL=records.js.map